import { render, staticRenderFns } from "./Resizer.vue?vue&type=template&id=b753f6b0&"
import script from "./Resizer.vue?vue&type=script&lang=js&"
export * from "./Resizer.vue?vue&type=script&lang=js&"
import style0 from "./Resizer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b753f6b0')) {
      api.createRecord('b753f6b0', component.options)
    } else {
      api.reload('b753f6b0', component.options)
    }
    module.hot.accept("./Resizer.vue?vue&type=template&id=b753f6b0&", function () {
      api.rerender('b753f6b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vendor/vue-js-modal/components/Resizer.vue"
export default component.exports